module.exports = __webpack_public_path__ + "static/work3-053561d18ca23264485db2736aa5c277.jpg";